module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAJCAYAAADgkQYQAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAQElEQVQYlWM0eNVex8DA0MSABzAxMDA0MjAw1BFSxEBIIRMSG6dCJjQ+VoXoirAqxKYIQyEuRSgKWfAogilkAAD+nwovCOWTpwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/pumpMonitor/leftOne/shoudong.png
// module id = 9MzJ
// module chunks = 157